import { hyperdbTriggers } from 'hyperdb-utils';
import httpRequest from '../../../helpers/httpRequest';
import upload from '../../../helpers/upload';
import * as config from '../../../../config';


const triggers = hyperdbTriggers({ config,
  namespace: 'AREA_CONTENT',
  entryPoint: '/area-contents',
  collectionName: 'area_contents',
  querySearchListing: [
    ['name', 'zone', ['content', ['id'] ]],
    { order: { id: 'asc' } }
  ],
  successMessageCreate: 'Area content created',
  successMessageUpdate: 'Area content updated',
  successMessageDelete: 'Area content deleted',
});

export default {
  ...triggers,
  savePicture(dispatch, getState, { typePicture, contentId, picture }) {
    const data = {...picture};
    const entryPoint = typePicture === 'picture' ? 'upload-picture' : 'upload-website-image';
    const url = config.APP_URL + `/area-contents/${contentId}/${entryPoint}`;
    const filename = data.filename[config.DEFAULT_LANGUAGE];
    const file = data.image_file || {};
    if (data._new) delete data._new;
    data.original = data.original || {
      $type: 'file',
      value: {
        name: file.name,
        content_type: file.type,
        size: file.size,
        mtime: (new Date(file.lastModified || 0)).toISOString(),
      }
    };
    data.thumbnail = data.thumbnail || { $type: 'file', value: {} };
    data.hi_res = data.hi_res || { $type: 'file', value: {} };
    dispatch({ type: 'AREA_CONTENT__UPLOAD_PICTURE' });
    return upload(url, data)
      .then(savedPicture => {
        dispatch({ type: 'AREA_CONTENT__UPLOAD_PICTURE_SUCCESS', payload: savedPicture });
      })
      .catch(err => {
        dispatch({ type: 'AREA_CONTENT__ERROR', payload: err });
      });
  },
  deletePicture(dispatch, getState, { typePicture, contentId, pictureId }) {
    const entryPoint = typePicture === 'picture' ? 'delete-picture' : 'delete-website-image';
    let url = config.APP_URL + `/area-contents/${contentId}/${entryPoint}`;
    if (typePicture === 'picture') url += `/${pictureId}`;
    dispatch({ type: 'AREA_CONTENT__DELETE_PICTURE' });
    return httpRequest('DELETE', url)
      .then(() => {
        dispatch({ type: 'AREA_CONTENT__DELETE_PICTURE_SUCCESS' });
      })
      .catch(err => {
        dispatch({ type: 'AREA_CONTENT__ERROR', payload: err });
      });
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/content/area-content/triggers.js